// Epidemos - System wielojezyczny (i18n)
// Wersja 1.0

const translations = {
  pl: {
    // Landing Page
    landing: {
      badge: "Nowa platforma AI Content Marketing",
      heroTitle1: "Publikuj artykuły.",
      heroTitle2: "Buduj widoczność.",
      heroDesc: "Platforma łącząca reklamodawców z wydawcami. Generuj treści AI, publikuj na setkach portali, monitoruj efekty. Wszystko w jednym miejscu.",
      ctaStart: "Zacznij za darmo",
      ctaBrowse: "Przeglądaj portale",
      statsPortals: "Portali w ofercie",
      statsArticles: "Opublikowanych artykułów",
      statsAdvertisers: "Reklamodawców",
      statsModels: "Modele AI",
      featuresTitle: "Wszystko czego potrzebujesz",
      featuresDesc: "Kompletna platforma do content marketingu z AI",
      feature1Title: "Publikacje na portalach",
      feature1Desc: "Zamów artykuły sponsorowane i linki na setkach portali w Polsce i Europie",
      feature2Title: "AI Content Generation",
      feature2Desc: "Generuj unikalne artykuły z pomocą 4 modeli AI: GPT-4o, Claude, Grok, Gemini",
      feature3Title: "Analiza SEO",
      feature3Desc: "Automatyczna analiza stron, frazy kluczowe, propozycje tematów i strategii",
      feature4Title: "Monitoring 24/7",
      feature4Desc: "AI monitor wykrywa błędy, analizuje przyczyny i sugeruje rozwiązania",
      feature5Title: "Masowa generacja",
      feature5Desc: "Generuj dziesiątki artykułów jednocześnie z automatycznym SEO i zdjęciami",
      feature6Title: "Hitowe tematy",
      feature6Desc: "Śledzenie trendów z Google Trends, Twittera i Reddita w czasie rzeczywistym",
      howTitle: "Jak to działa?",
      how1Title: "Dla Reklamodawców",
      how1Desc: "Przeglądaj portale, wybierz usługę (artykuł, link, baner), złóż zamówienie. Możesz zamówić bez konta!",
      how2Title: "AI generuje treść",
      how2Desc: "System AI dobiera najlepszy model, generuje unikalny artykuł z SEO, zdjęciem i meta tagami.",
      how3Title: "Dla Wydawców",
      how3Desc: "Dodaj portal, ustaw ceny, akceptuj zamówienia. Zarabiaj na publikacjach. Możesz być jednocześnie wydawcą i reklamodawcą!",
      blogTitle: "Blog",
      blogDesc: "Najnowsze artykuły i poradniki",
      readMore: "Czytaj więcej",
      ctaTitle: "Gotowy na więcej widoczności?",
      ctaDesc: "Dołącz do tysięcy firm, które budują swoją obecność online z Epidemos.",
      ctaFree: "Załóż darmowe konto",
      ctaShop: "Przeglądaj sklep",
    },
    // Header
    header: {
      features: "Funkcje",
      blog: "Blog",
      shop: "Sklep",
      login: "Zaloguj",
      register: "Załóż konto",
    },
    // Footer
    footer: {
      desc: "Platforma łącząca reklamodawców z wydawcami. Publikuj artykuły, buduj linki, zwiększaj widoczność.",
      product: "Produkt",
      features: "Funkcje",
      pricing: "Cennik",
      shop: "Sklep",
      blog: "Blog",
      company: "Firma",
      about: "O nas",
      contact: "Kontakt",
      legal: "Prawne",
      terms: "Regulamin",
      privacy: "Polityka prywatności",
      rights: "Wszelkie prawa zastrzeżone.",
    },
    // Features Page
    featuresPage: {
      heroTitle: "Kompletna platforma",
      heroTitle2: "content marketingu",
      heroDesc: "Wszystko czego potrzebujesz do budowania widoczności w sieci. Dla reklamodawców i wydawców.",
      ctaStart: "Zacznij za darmo",
      ctaShop: "Zobacz oferty",
      tabAdvertiser: "Dla Reklamodawców",
      tabPublisher: "Dla Wydawców",
      // Advertiser features
      advMarketplace: "Marketplace portali",
      advMarketplaceDesc: "Przeglądaj setki zweryfikowanych portali z różnymi kategoriami tematycznymi. Filtruj po branży, cenie, parametrach SEO i zasięgach.",
      advOrdering: "Zamawianie artykułów",
      advOrderingDesc: "Zamów artykuł sponsorowany lub dostarcz własny tekst. Wybierz typ publikacji: artykuł, baner, link w treści lub wpis w social media.",
      advAiGen: "Generator AI treści",
      advAiGenDesc: "Wygeneruj profesjonalny artykuł za pomocą sztucznej inteligencji. Wybierz temat, ton i długość - reszta zostanie zrobiona automatycznie.",
      advNegotiation: "Negocjacje cen",
      advNegotiationDesc: "Negocjuj ceny bezpośrednio z wydawcami. System negocjacji pozwala na uzyskanie lepszych warunków przy większych zamówieniach.",
      advWallet: "Portfel Zorki",
      advWalletDesc: "Wirtualna waluta Epidemos. Doładuj portfel i płać za zamówienia bez prowizji. Możliwość ubiegania się o kredyt na publikacje.",
      advReports: "Panel raportów",
      advReportsDesc: "Śledź status swoich zamówień w czasie rzeczywistym. Pobieraj raporty z opublikowanych artykułów i monitoruj efekty.",
      // Publisher features
      pubAddSites: "Dodawanie portali",
      pubAddSitesDesc: "Dodaj swoje strony internetowe do marketplace. Ustaw cennik, kategorie i typy akceptowanych publikacji.",
      pubWordpress: "Integracja API WordPress",
      pubWordpressDesc: "Jako PIERWSZA platforma w Polsce oferujemy pełną integrację z WordPress! Artykuły publikują się automatycznie na Twojej stronie.",
      pubManageOffers: "Zarządzanie ofertami",
      pubManageOffersDesc: "Twórz cenniki dla każdej strony osobno. Ustal ceny za artykuły, banery, linki i wpisy social media.",
      pubModeration: "Moderacja zamówień",
      pubModerationDesc: "Przeglądaj i akceptuj zamówienia przed publikacją. Masz pełną kontrolę nad treściami na swoich portalach.",
      pubEarnings: "Zarobki i wypłaty",
      pubEarningsDesc: "Śledź swoje zarobki w panelu. Zamawiaj wypłaty na konto bankowe lub PayPal bez minimalnych progów.",
      pubRss: "Źródła RSS",
      pubRssDesc: "Dodaj źródła RSS do automatycznego importu artykułów. System pobiera treści i przygotowuje je do publikacji.",
      // Upcoming
      upcomingTitle: "Nadchodzące funkcje",
      upcomingDesc: "Pracujemy nad nowymi możliwościami",
      upcoming1: "Baza artykułów gościnnych",
      upcoming1Desc: "Gotowe artykuły do pobrania z bazy. AI wyszukuje i przygotowuje treści dopasowane do Twojej branży.",
      upcoming2: "Newsy znalezione przez AI",
      upcoming2Desc: "Automatyczne wyszukiwanie aktualnych newsów i trendów. AI generuje artykuły na podstawie bieżących wydarzeń.",
      upcoming3: "Baza linków i domen",
      upcoming3Desc: "Rozbudowana baza domen z parametrami SEO. Znajdź najlepsze miejsca do linkowania.",
      upcoming4: "Kampanie automatyczne",
      upcoming4Desc: "Ustaw budżet i cele - AI dobierze najlepsze portale i rozłoży publikacje w czasie.",
      statusInPrep: "W przygotowaniu",
      statusSoon: "Wkrótce",
      statusPlanned: "Planowane",
      // Benefits
      benefitsTitle: "Dlaczego Epidemos?",
      benefit1: "Oszczędność czasu - automatyzacja publikacji",
      benefit2: "Bezpieczeństwo - weryfikowane portale",
      benefit3: "Efekty SEO - budowanie linków",
      benefit4: "Sieć wydawców - setki portali",
      benefit5: "AI - generowanie treści",
      benefit6: "24/7 - dostęp do platformy",
      // CTA
      ctaTitle: "Gotowy na więcej widoczności?",
      ctaDesc: "Dołącz do tysięcy firm budujących swoją obecność online",
      ctaFreeAccount: "Załóż darmowe konto",
      // Stats
      statsPortals: "Portali w sieci",
      statsArticles: "Opublikowanych artykułów",
      statsAdvertisers: "Reklamodawców",
      statsModels: "Modele AI",
    },
    // Public Shop
    publicShop: {
      title: "Marketplace",
      subtitle: "Zamów artykuły sponsorowane i linki na sprawdzonych portalach",
      searchPlaceholder: "Szukaj portalu...",
      allCategories: "Wszystkie kategorie",
      results: "wyników",
      noResults: "Brak portali spełniających kryteria",
      noResultsHint: "Spróbuj zmienić filtry lub wyszukiwanie",
      article: "Artykuł",
      link: "Link",
      banner: "Baner",
      order: "Zamów",
      details: "Szczegóły",
      visitors: "odwiedzin/mies.",
      delivery: "dni realizacji",
      from: "od",
      loginToOrder: "Zaloguj się aby zamówić",
      guestOrder: "Zamów bez konta",
      negotiate: "Negocjuj cenę",
      commission: "Prowizja portalu",
      // Order dialog
      orderTitle: "Nowe zamówienie",
      selectService: "Wybierz usługę",
      orderDetails: "Szczegóły zamówienia",
      summary: "Podsumowanie",
      articleTitle: "Tytuł artykułu",
      articleContent: "Treść artykułu",
      contentHint: "Zostaw puste - wydawca napisze artykuł",
      requirements: "Wymagania dodatkowe",
      requirementsPlaceholder: "Dodatkowe wskazówki dla wydawcy...",
      yourEmail: "Twój email",
      emailHint: "Na ten adres otrzymasz informacje o statusie",
      next: "Dalej",
      back: "Wstecz",
      placeOrder: "Złóż zamówienie",
      orderPlaced: "Zamówienie złożone!",
      orderPlacedDesc: "Wydawca otrzymał powiadomienie i wkrótce się odezwie",
      total: "Do zapłaty",
      service: "Usługa",
      portal: "Portal",
      // Negotiation
      negotiateTitle: "Negocjuj cenę",
      proposedPrice: "Proponowana cena",
      message: "Wiadomość do wydawcy",
      sendOffer: "Wyślij ofertę",
      offerSent: "Oferta wysłana",
    },
    // Auth
    auth: {
      login: "Logowanie",
      register: "Rejestracja",
      identifier: "Login",
      identifierPlaceholder: "Email, telefon lub nick",
      identifierHint: "Mozesz uzyc email, numeru telefonu lub nicka",
      password: "Haslo",
      role: "Rola",
      advertiser: "Reklamodawca",
      publisher: "Wydawca",
      loginBtn: "Zaloguj sie",
      registerBtn: "Zarejestruj sie",
      loginSuccess: "Zalogowano pomyslnie",
      registerSuccess: "Konto utworzone",
      logout: "Wyloguj",
    },
    // Sklep Reklamodawcow
    shop: {
      title: "Sklep Reklamodawcow",
      subtitle: "Zamow artykuly, linki i banery na portalach wydawcow",
      searchTab: "Szukaj portali",
      myOrders: "Moje zamowienia",
      searchPlaceholder: "Szukaj portalu...",
      allCategories: "Wszystkie kategorie",
      allRegions: "Wszystkie regiony",
      results: "wynikow",
      noResults: "Brak ofert wydawcow",
      addOffersHint: "Dodaj oferty w panelu wydawcy",
      article: "Artykul",
      link: "Link",
      banner: "Baner",
      order: "Zamow",
      noOrders: "Brak zamowien",
      newOrder: "Nowe zamowienie",
      selectType: "Wybierz typ uslugi",
      next: "Dalej",
      back: "Wstecz",
      summary: "Podsumowanie",
      orderTitle: "Tytul",
      orderTitlePlaceholder: "Tytul artykulu lub opis...",
      orderContent: "Tresc artykulu",
      contentPlaceholder: "Wpisz tresc lub zostawej puste - wydawca napisze",
      linkUrl: "URL linku",
      requirements: "Wymagania",
      requirementsPlaceholder: "Dodatkowe wskazowki...",
      guestEmail: "Email kontaktowy",
      guestHint: "Zamowienie bez konta - otrzymasz status na email",
      enterEmail: "Podaj email",
      portal: "Portal",
      type: "Typ",
      delivery: "Realizacja",
      days: "dni",
      total: "Do zaplaty",
      placeOrder: "Zloz zamowienie",
      orderCreated: "Zamowienie zlozone",
      portals: "portali",
      portalsSelected: "portali wybranych",
      orderMulti: "Zamow na wybranych",
      stripeNote: "Platnosc: Stripe (placeholder). Wydawca otrzyma powiadomienie.",
    },
    // Panel Wydawcy
    pub: {
      title: "Panel Wydawcy",
      subtitle: "Zarzadzaj stronami, ofertami i zamowieniami",
      sitesTab: "Moje strony",
      ordersTab: "Zamowienia",
      mySites: "Strony",
      totalOrders: "Zamowienia",
      pendingOrders: "Oczekujace",
      completedOrders: "Zrealizowane",
      revenue: "Przychod",
      addSite: "Dodaj strone",
      siteName: "Nazwa portalu",
      category: "Kategoria",
      region: "Region",
      pricing: "Cennik uslug",
      pubPrice: "Publikacja",
      writePrice: "Pisanie",
      linkPrice: "Link",
      description: "Opis",
      noSites: "Brak stron. Dodaj swoj portal!",
      noOrders: "Brak zamowien",
      pending: "oczekujace",
      accepted: "Zaakceptowane",
      completed: "Zrealizowane",
      ordersTotal: "zamowien",
      accept: "Akceptuj",
      reject: "Odrzuc",
      markComplete: "Zrealizuj",
      siteAdded: "Strona dodana z oferta",
      platform: "Platforma",
      wpUser: "Uzytkownik WP",
      wpPass: "Application Password",
      manualApproval: "Reczna akceptacja publikacji",
      manualApprovalHint: "Wlacz jesli chcesz zatwierdzac kazda publikacje recznie",
    },
    // Panel Admina
    admin: {
      title: "Panel Admina",
      subtitle: "Zarzadzanie systemem, uzytkownikami i zamowieniami",
      noAccess: "Brak dostepu - wymagana rola Admin",
      overviewTab: "Przeglad",
      usersTab: "Uzytkownicy",
      ordersTab: "Zamowienia",
      users: "Uzytkownicy",
      sites: "Strony",
      orders: "Zamowienia",
      revenue: "Przychod",
      posts: "Artykuly",
      userBreakdown: "Uzytkownicy wg roli",
      orderBreakdown: "Zamowienia wg statusu",
      financials: "Finanse",
      totalRevenue: "Calkowity przychod ze zamowien",
      userIdent: "Identyfikator",
      displayName: "Nazwa",
      role: "Rola",
      registered: "Data rejestracji",
      noOrders: "Brak zamowien",
      orderType: "Typ",
      site: "Portal",
      client: "Klient",
      price: "Cena",
    },
    // Nawigacja
    nav: {
      dashboard: "Panel Glowny",
      shop: "Sklep",
      myOrders: "Moje zamowienia",
      myNegotiations: "Moje negocjacje",
      zorki: "Portfel Zorkow",
      publisher: "Panel Wydawcy",
      admin: "Panel Admina",
      sites: "Strony",
      htmlGenerator: "Generator HTML",
      generator: "Generator Tresci",
      monitor: "AI Monitor",
      trends: "Hitowe Tematy",
      rewrite: "Przepisz Artykul",
      massGen: "Masowa Generacja",
      autoPublish: "Auto Publisher",
      keywordResearch: "Keyword Research",
      breakingNews: "Breaking News",
      performance: "Efektywnosc",
      internalLinking: "Linkowanie Wewn.",
      clickbait: "Optymalizacja CTR",
      twitterAnalysis: "Analiza X/Twitter",
      seoAgent: "SEO Agent",
      affiliates: "Produkty Afiliacyjne",
      woo: "WooCommerce",
      social: "Social Media",
      reports: "Raportowanie",
      comments: "Komentarze",
      forums: "Fora",
      connectors: "API Konektory",
      extensions: "Rozszerzenia",
      subscription: "Subskrypcja",
      mail: "Poczta",
      messages: "Wiadomosci",
      media: "Biblioteka Mediow",
      rss: "Zrodla RSS",
      queue: "Kolejka Postow",
      tasks: "Zadania",
      settings: "Ustawienia",
      collapse: "Zwin menu",
    },
    // HTML Generator
    htmlGen: {
      title: "Generator Serwisow HTML",
      subtitle: "Tworzenie kompletnych stron HTML z AI i deploy przez FTP",
      wizard: "Kreator",
      history: "Historia generacji",
      maxVersions: "Max 3 wersje per domena",
      noHistory: "Brak historii generacji",
      stepDomain: "Domena",
      stepAnalysis: "Analiza AI",
      stepTemplate: "Szablon",
      stepFtp: "FTP",
      stepGenerate: "Generuj",
      stepPreview: "Podglad",
      domainLabel: "Domena",
      aiModelLabel: "Model AI",
      analyzeDomain: "Analizuj domene",
      analyzing: "Analizowanie...",
      analysisComplete: "Analiza zakonczona",
      analysisResult: "Wynik analizy",
      category: "Kategoria",
      language: "Jezyk",
      siteTitle: "Tytul strony",
      siteDesc: "Opis strony",
      keywords: "Slowa kluczowe",
      suggestedArticles: "Sugerowane artykuly",
      enterDomain: "Wpisz domene",
      selectTemplate: "Wybierz szablon",
      selected: "Wybrany",
      template: "Szablon",
      ftpConfig: "Konfiguracja FTP",
      ftpOptional: "FTP jest opcjonalne. Mozesz pomin ten krok i pobrac pliki recznie.",
      ftpHost: "Host FTP",
      ftpUser: "Uzytkownik FTP",
      ftpPass: "Haslo FTP",
      enterFtpHost: "Wpisz host FTP",
      testFtp: "Testuj polaczenie",
      generateSummary: "Podsumowanie i generowanie",
      generateWillCreate: "System wygeneruje nastepujace pliki:",
      generateNow: "Generuj strone",
      generating: "Generowanie...",
      generateSuccess: "Strona wygenerowana pomyslnie",
      previewTitle: "Podglad strony",
      generated: "Wygenerowano",
      deployFtp: "Deploy na FTP",
      newGeneration: "Nowa generacja",
      date: "Data",
      back: "Wstecz",
      nextTemplate: "Wybierz szablon",
      nextFtp: "Konfiguracja FTP",
      nextGenerate: "Podsumowanie",
    },
    // Dashboard
    dashboard: {
      title: "Panel Glowny",
      subtitle: "Centralny panel zarzadzania Epidemos",
      sites: "Strony",
      posts: "Artykuly",
      published: "Opublikowane",
      drafts: "Szkice",
      pending: "Oczekujace",
      activeJobs: "Aktywne zadania AI",
      rssFeeds: "Zrodla RSS",
      pendingTasks: "Zadania do zrobienia",
      totalJobs: "Wszystkie zadania",
      recentActivity: "Ostatnia aktywnosc",
      quickActions: "Szybkie akcje",
      addSite: "Dodaj strone",
      generateArticle: "Generuj artykul",
      addFeed: "Dodaj zrodlo RSS",
      createTask: "Utworz zadanie",
      noActivity: "Brak aktywnosci",
      wpSites: "Strony WordPress",
      htmlSites: "Strony HTML",
      activeSites: "Aktywne strony",
      totalArticles: "Lacznie artykulow",
      recentJobs: "Ostatnie zadania AI",
      noJobs: "Brak zadan AI",
      jobType: "Typ zadania",
      jobStatus: "Status",
      jobModel: "Model AI",
      jobDate: "Data",
      systemModules: "Moduly systemu",
      moduleActive: "Aktywny",
      modulePlanned: "Planowany",
      subscription: "Subskrypcja",
      plan: "Plan",
      free: "Darmowy",
      pro: "Profesjonalny",
      enterprise: "Enterprise",
      sitesUsed: "Strony",
      postsUsed: "Artykuly",
      aiUsage: "Uzycie modeli AI",
      generate: "generate",
      rewrite: "rewrite",
      seo_analyze: "seo_analyze",
      mass_generate: "mass_generate",
      completedJobs: "Zakonczone",
      failedJobs: "Nieudane",
      tasksInProgress: "W trakcie",
      tasksDone: "Zakonczone",
      refreshData: "Odswiez dane",
      lastUpdate: "Ostatnia aktualizacja",
    },
    // Strony
    sites: {
      title: "Zarzadzanie stronami",
      subtitle: "WordPress i strony HTML",
      addSite: "Dodaj strone",
      name: "Nazwa strony",
      url: "Adres URL",
      type: "Typ strony",
      wordpress: "WordPress",
      html: "HTML",
      status: "Status",
      active: "Aktywna",
      inactive: "Nieaktywna",
      actions: "Akcje",
      edit: "Edytuj",
      delete: "Usun",
      save: "Zapisz",
      cancel: "Anuluj",
      noSites: "Brak stron. Dodaj pierwsza strone!",
      ftpHost: "Host FTP",
      ftpUser: "Uzytkownik FTP",
      ftpPass: "Haslo FTP",
      wpApiUrl: "WordPress API URL",
      wpApiUser: "WordPress uzytkownik",
      wpApiPass: "WordPress haslo",
      confirmDelete: "Czy na pewno chcesz usunac te strone?",
    },
    // WordPress zaawansowane
    wp: {
      overview: "Przeglad",
      aiAnalysis: "Analiza AI",
      pricing: "Cennik reklam",
      directories: "Katalogi",
      testConnection: "Testuj polaczenie",
      connectionOk: "Polaczenie udane",
      connectionFail: "Polaczenie nie powiodlo sie",
      posts: "artykulow",
      category: "Kategoria",
      region: "Region",
      audience: "Grupa docelowa",
      traffic: "Ruch",
      assignCategory: "Przypisz kategorie",
      assignRegion: "Przypisz region",
      publishedArticles: "Opublikowane",
      backlinks: "Backlinki",
      runAnalysis: "Uruchom analize AI",
      analyzing: "Analizowanie...",
      analysisComplete: "Analiza zakonczona",
      categories: "Kategorie",
      strengths: "Mocne strony",
      suggestedTopics: "Propozycje tematow",
      seoKeywords: "Slowa kluczowe SEO",
      seoStrategies: "Strategie SEO",
      analyzedAt: "Analizowano",
      generatePricing: "Generuj cennik reklam",
      generatingPricing: "Generowanie cennika...",
      pricingGenerated: "Cennik wygenerowany",
      adType: "Typ reklamy",
      duration: "Czas trwania",
      price: "Cena",
      pricingGenAt: "Wygenerowano",
      directoriesDesc: "Wyslij strone do katalogow aby zwiekszyc widocznosc i zdobyc backlinki.",
      submitDirectories: "Wyslij do katalogow",
      directoriesSubmitted: "Wyslano do katalogow",
      sent: "Wyslano",
    },
    // AI Monitor
    monitor: {
      title: "AI Monitor",
      subtitle: "Monitoring bledow i automatyczna analiza AI",
      runScan: "Skanuj system",
      scanning: "Skanowanie...",
      scanComplete: "Skan zakonczony",
      errorsFound: "bledow wykrytych",
      newAlerts: "nowych alertow",
      totalAlerts: "Wszystkie alerty",
      critical: "Krytyczne",
      highPriority: "Wysokie",
      resolved: "Rozwiazane",
      alertsList: "Lista alertow",
      noAlerts: "Brak alertow - system dziala poprawnie",
      allSeverity: "Waznosc",
      allStatus: "Status",
      statusNew: "Nowy",
      statusAck: "Potwierdzony",
      statusResolved: "Rozwiazany",
      statusIgnored: "Zignorowany",
      details: "Szczegoly",
      aiAnalysis: "Analiza AI",
      analyzeError: "Analizuj blad",
      analyzing: "Analizowanie...",
      analysisComplete: "Analiza zakonczona",
      cause: "Przyczyna",
      solution: "Rozwiazanie",
      urgent: "Pilne",
      impact: "Wplyw",
      acknowledge: "Potwierdz",
      resolve: "Rozwiaz",
      ignore: "Ignoruj",
      lastScan: "Ostatni skan",
    },
    // Hitowe Tematy
    trends: {
      title: "Hitowe Tematy",
      subtitle: "Trendujace tematy z Google Trends, Twittera i Reddita",
      fetchTrends: "Pobierz trendy",
      fetching: "Pobieranie...",
      fetchComplete: "Pobieranie zakonczone",
      topicsFetched: "tematow pobranych",
      saved: "zapisanych",
      addManual: "Dodaj reczny temat",
      topicTitle: "Tytul tematu",
      topicDesc: "Opis",
      category: "Kategoria",
      source: "Zrodlo",
      expiresIn: "Wygasa za",
      keywords: "Slowa kluczowe",
      activeTrends: "Aktywne trendy",
      expired: "Wygasly",
      allCategories: "Wszystkie kategorie",
      allSources: "Wszystkie zrodla",
      noTrends: "Brak trendow. Pobierz nowe tematy!",
      timeLeft: "Pozostalo",
      used: "Uzyty",
      aiScoring: "Ocena AI",
      scoreNow: "Ocen temat",
      scored: "Ocena zapisana",
      competition: "Konkurencja",
      traffic: "Ruch",
      bestTime: "Najlepszy czas",
      altTitles: "Alternatywne tytuly",
      generateArticle: "Generuj artykul z tego tematu",
      lastFetch: "Ostatnie pobieranie",
    },
    // Przepisz Artykul
    rewrite: {
      title: "Przepisz Artykul",
      subtitle: "Unikalizacja tresci z pomoca AI",
      rewriteTab: "Przepisz",
      historyTab: "Historia",
      sourceUrl: "Zrodlowy URL",
      enterUrl: "Wpisz URL artykulu",
      scrape: "Pobierz",
      scraped: "Pobrano",
      words: "slow",
      options: "Opcje przepisywania",
      aiModel: "Model AI",
      language: "Jezyk",
      tone: "Ton",
      tonePro: "Profesjonalny",
      toneCasual: "Swobodny",
      toneSeo: "SEO",
      targetSite: "Strona docelowa",
      autoSeo: "Auto SEO meta tagi",
      saveAs: "Zapisz jako",
      asDraft: "Szkic",
      asPending: "Oczekujacy",
      rewriteNow: "Przepisz artykul",
      rewriting: "Przepisywanie...",
      rewriteComplete: "Artykul przepisany",
      newRewrite: "Nowe przepisanie",
      originalPreview: "Podglad oryginalu",
      rewrittenPreview: "Podglad przepisanego",
      done: "Gotowe",
      pasteUrlHint: "Wklej URL artykulu do przepisania",
      noHistory: "Brak historii przepisan",
    },
    // Masowa Generacja
    mass: {
      title: "Masowa Generacja",
      subtitle: "Generowanie wielu artykulow jednoczesnie z AI",
      generateTab: "Generuj",
      historyTab: "Historia",
      modeAndTopics: "Tryb i tematy",
      mode: "Tryb",
      modeCustom: "Wlasne",
      modeReviews: "Recenzje",
      modeLocal: "Lokalne",
      category: "Kategoria",
      topicPlaceholder: "Wpisz temat artykulu...",
      add: "Dodaj",
      suggest: "Sugeruj AI",
      suggested: "Zasugerowano tematow",
      noTopics: "Dodaj tematy reczne lub uzyj sugestii AI",
      topicsAdded: "tematow",
      addTopicsFirst: "Najpierw dodaj tematy",
      settings: "Ustawienia generacji",
      aiModel: "Model AI",
      language: "Jezyk",
      tone: "Ton",
      tonePro: "Profesjonalny",
      toneCasual: "Swobodny",
      wordCount: "Dlugosc",
      targetSite: "Strona docelowa",
      includeFaq: "Dolacz sekcje FAQ",
      includeLinks: "Linki wewnetrzne",
      saveAs: "Zapisz jako",
      asDraft: "Szkic",
      asPending: "Oczekujacy",
      generateBatch: "Generuj batch",
      generatingBatch: "Generowanie...",
      pleaseWait: "To moze potrwac kilka minut...",
      generated: "Wygenerowano",
      articles: "artykulow",
      articlesGenerated: "artykulow wygenerowanych",
      failed: "nieudanych",
      words: "slow",
      newBatch: "Nowy batch",
      noBatches: "Brak historii generacji",
    },
    // Produkty Afiliacyjne
    affil: {
      title: "Produkty Afiliacyjne",
      subtitle: "Zarzadzanie produktami do promocji w artykulach",
      addProduct: "Dodaj produkt",
      productName: "Nazwa produktu",
      productUrl: "URL produktu",
      description: "Opis",
      imageUrl: "URL obrazka",
      category: "Kategoria",
      tags: "Tagi",
      priority: "Priorytet",
      status: "Status",
      active: "Aktywny",
      inactive: "Nieaktywny",
      ctaText: "Tekst CTA",
      commission: "Prowizja",
      autoInsert: "Auto-wstawianie",
      total: "lacznie",
      allCategories: "Wszystkie",
      noProducts: "Brak produktow afiliacyjnych",
    },
    // WooCommerce
    woo: {
      title: "Produkty WooCommerce",
      subtitle: "Zarzadzanie produktami do sprzedazy",
      addProduct: "Dodaj produkt",
      productName: "Nazwa produktu",
      regularPrice: "Cena",
      salePrice: "Cena promocyjna",
      costPrice: "Koszt",
      margin: "Marza",
      shortDesc: "Krotki opis",
      category: "Kategoria",
      tags: "Tagi",
      imageUrl: "URL obrazka",
      stock: "Dostepnosc",
      inStock: "Dostepny",
      outOfStock: "Niedostepny",
      targetSite: "Strona WP",
      publish: "Publikuj",
      published: "Opublikowano",
      totalProducts: "Produkty",
      publishedProducts: "Opublikowane",
      draftProducts: "Szkice",
      noProducts: "Brak produktow WooCommerce",
    },
    // Social Media
    social: {
      title: "Social Media",
      subtitle: "Planowanie i publikacja postow na platformach spolecznosciowych",
      createPost: "Utworz post",
      platforms: "Platformy",
      content: "Tresc",
      contentPlaceholder: "Napisz tresc posta...",
      imageUrl: "URL obrazka",
      linkUrl: "URL linku",
      scheduleAt: "Zaplanuj na",
      enterContent: "Wpisz tresc posta",
      selectPlatform: "Wybierz platforme",
      publish: "Opublikuj",
      published: "Opublikowano",
      totalPosts: "Posty",
      scheduled: "Zaplanowane",
      publishedCount: "Opublikowane",
      noPosts: "Brak postow social media",
    },
    // Raportowanie Mobilne
    reports: {
      title: "Raportowanie Mobilne",
      subtitle: "Przyjmowanie i przetwarzanie raportow z terenu",
      submitReport: "Zglos raport",
      headline: "Naglowek",
      content: "Tresc",
      location: "Lokalizacja",
      category: "Kategoria",
      reporter: "Reporter",
      submit: "Wyslij",
      totalReports: "Raporty",
      newReports: "Nowe",
      approvedReports: "Zatwierdzone",
      noReports: "Brak raportow",
      aiSuggestions: "Sugestie AI",
      getSuggestions: "Sugeruj",
      suggested: "Sugestie zapisane",
      suggestedTitle: "Sugerowany tytul",
      suggestedStyle: "Styl",
      approve: "Zatwierdz",
      reject: "Odrzuc",
    },
    // Komentarze
    comments: {
      title: "Komentarze",
      subtitle: "Zarzadzanie komentarzami i automatyczne odpowiedzi AI",
      addManual: "Dodaj komentarz",
      importWp: "Importuj z WP",
      imported: "Zaimportowano",
      author: "Autor",
      content: "Tresc komentarza",
      postTitle: "Tytul posta",
      total: "lacznie",
      new: "nowych",
      repliedCount: "z odpowiedzia",
      allSources: "Wszystkie",
      noComments: "Brak komentarzy",
      analyzeSentiment: "Sentyment",
      aiReply: "Odpowiedz AI",
      generateReply: "Generuj",
      replied: "Odpowiedz wygenerowana",
      toneFriendly: "Przyjazny",
      tonePro: "Profesjonalny",
      toneHumor: "Z humorem",
    },
    // Fora
    forums: {
      title: "Fora",
      subtitle: "Publikacja na forach internetowych (MyBB, phpBB)",
      addForum: "Dodaj forum",
      createPost: "Utworz post AI",
      forumsTab: "Fora",
      postsTab: "Posty",
      forumName: "Nazwa forum",
      forumUrl: "URL forum",
      selectForum: "Wybierz forum",
      postTitle: "Tytul posta",
      postContent: "Tresc",
      contentHint: "Wpisz temat lub szkic - AI rozbuduje tresc",
      category: "Kategoria",
      other: "Inne",
      generateAndSave: "Generuj i zapisz",
      postCreated: "Post wygenerowany",
      publish: "Opublikuj",
      published: "Opublikowano",
      posts: "postow",
      discussions: "dyskusji",
      noForums: "Brak for. Dodaj pierwsze forum!",
      noPosts: "Brak postow forumowych",
      sectionId: "ID sekcji",
      apiKey: "Klucz API",
      tags: "Tagi",
      forumsCount: "Fora",
      postsCount: "Posty",
      pendingApproval: "Oczekujace",
      publishedCount: "Opublikowane",
      approved: "Zatwierdzony",
      rejected: "Odrzucony",
      approve: "Zatwierdz",
      reject: "Odrzuc",
      aiGenerated: "Tresc AI",
      replies: "Odpowiedzi",
      views: "Wyswietlenia",
    },
    // API Konektory
    conn: {
      title: "API Konektory",
      subtitle: "Konfiguracja polaczen z zewnetrznymi uslugami",
      addConnector: "Dodaj konektor",
      connName: "Nazwa",
      platform: "Platforma",
      apiUrl: "URL API",
      apiKey: "Klucz API",
      authType: "Typ autoryzacji",
      capabilities: "Mozliwosci",
      rateLimit: "Rate limit (/h)",
      costPerCall: "Koszt / call",
      testConnection: "Testuj polaczenie",
      noConnectors: "Brak konektorow API",
    },
    // Rozszerzenia
    ext: {
      title: "Rozszerzenia",
      subtitle: "Dodatkowe moduly i integracje dla systemu Epidemos",
      total: "dostepnych",
      installedCount: "zainstalowanych",
      installedSection: "Zainstalowane",
      availableSection: "Dostepne do instalacji",
      install: "Zainstaluj",
      installed: "Zainstalowano",
      uninstall: "Odinstaluj",
      uninstalled: "Odinstalowano",
    },
    // Subskrypcja
    sub: {
      title: "Subskrypcja",
      subtitle: "Zarzadzanie planem i limitami konta",
      currentPlan: "Aktualny plan",
      currentPlanBtn: "Aktualny plan",
      sites: "Strony",
      postsMonth: "Posty/mc",
      aiCalls: "AI calls/mc",
      rssFeeds: "RSS feeds",
      expiresAt: "Wazny do",
      month: "mc",
      upgrade: "Zmien plan",
      downgrade: "Zmien",
      planChanged: "Plan zmieniony",
      stripeNote: "Platnosci obslugiwane przez Stripe. Subskrypcje mozna anulowac w kazdej chwili.",
    },
    // Biblioteka Mediow
    media: {
      title: "Biblioteka Mediow",
      subtitle: "Bank zdjec z kategoriami i AI tagowaniem",
      bulkUpload: "Dodaj zdjecia hurtowo",
      selectCategory: "Kategoria zdjec",
      selectFiles: "Wybierz pliki",
      filesSelected: "plikow wybranych",
      upload: "Wgraj",
      noMedia: "Brak zdjec w bibliotece",
      uploadHint: "Dodaj zdjecia hurtowo wybierajac kategorie",
    },
    generator: {
      title: "Generator Tresci AI",
      subtitle: "Tworzenie artykulow z pomoca AI",
      topic: "Temat artykulu",
      topicPlaceholder: "Wpisz temat artykulu...",
      model: "Model AI",
      language: "Jezyk",
      tone: "Ton",
      toneOptions: {
        professional: "Profesjonalny",
        casual: "Swobodny",
        seo: "Zoptymalizowany SEO",
      },
      wordCount: "Liczba slow",
      keywords: "Slowa kluczowe SEO",
      keywordsPlaceholder: "Oddziel przecinkami...",
      targetSite: "Strona docelowa",
      selectSite: "Wybierz strone (opcjonalne)",
      generate: "Generuj artykul",
      generating: "Generowanie...",
      preview: "Podglad artykulu",
      noContent: "Wygeneruj artykul aby zobaczyc podglad",
      saveAsDraft: "Zapisz jako szkic",
      copyContent: "Kopiuj tresc",
      wordsGenerated: "slow wygenerowanych",
      modelUsed: "Uzyty model",
    },
    // RSS
    rss: {
      title: "Zrodla RSS",
      subtitle: "Zarzadzanie kanaly RSS",
      addFeed: "Dodaj zrodlo",
      name: "Nazwa",
      url: "URL kanalu",
      autoImport: "Automatyczny import",
      interval: "Interwał sprawdzania (min)",
      lastChecked: "Ostatnie sprawdzenie",
      imported: "Zaimportowano",
      noFeeds: "Brak zrodel RSS. Dodaj pierwsze zrodlo!",
      save: "Zapisz",
      cancel: "Anuluj",
      delete: "Usun",
    },
    // RSS zaawansowane
    rssAdv: {
      feedsTab: "Zrodla",
      pendingTab: "Oczekujace",
      test: "Testuj",
      testOk: "Feed poprawny",
      testFail: "Blad feeda",
      articles: "artykulow",
      found: "znalezionych",
      import: "Importuj",
      imported: "Zaimportowano",
      targetSite: "Strona docelowa",
      lastCheck: "Ostatni import",
      noPending: "Brak artykulow oczekujacych",
      original: "Oryginal",
      aiRating: "Ocena AI",
      rateArticle: "Ocen artykul",
      rated: "Ocena zapisana",
      quality: "Jakosc",
      relevance: "Trafnosc",
      rewritePotential: "Potencjal przepisania",
      action: "Rekomendacja",
      approve: "Zatwierdz",
      reject: "Odrzuc",
      statusPending: "Oczekujace",
      statusApproved: "Zatwierdzone",
      statusRejected: "Odrzucone",
    },
    queue: {
      title: "Kolejka Postow",
      subtitle: "Artykuly oczekujace na publikacje",
      noPosts: "Brak postow w kolejce",
      publish: "Opublikuj",
      edit: "Edytuj",
      delete: "Usun",
      filter: "Filtruj",
      all: "Wszystkie",
      draft: "Szkice",
      pending: "Oczekujace",
      published: "Opublikowane",
    },
    // Kolejka zaawansowana
    queueAdv: {
      total: "Wszystkie",
      drafts: "Szkice",
      pending: "Oczekujace",
      publishedCount: "Opublikowane",
      rejectedCount: "Odrzucone",
      selected: "wybranych",
      approveSelected: "Zatwierdz",
      rejectSelected: "Odrzuc",
      approved: "Zatwierdzono",
      rejected: "Odrzucono",
      published: "Opublikowano",
      titleCol: "Tytul",
      statusCol: "Status",
      siteCol: "Strona",
      wordsCol: "Slow",
      dateCol: "Data",
      page: "Strona",
      words: "slow",
      preview: "Podglad",
      assignSite: "Przypisz strone",
      publishNow: "Opublikuj teraz",
      moveToPending: "Do oczekujacych",
      reject: "Odrzuc",
      created: "Utworzono",
    },
    tasks: {
      title: "Zadania",
      subtitle: "Zarzadzanie zadaniami systemowymi",
      addTask: "Dodaj zadanie",
      taskTitle: "Tytul zadania",
      description: "Opis",
      priority: "Priorytet",
      priorities: {
        low: "Niski",
        medium: "Sredni",
        high: "Wysoki",
        critical: "Krytyczny",
      },
      status: "Status",
      statuses: {
        todo: "Do zrobienia",
        in_progress: "W trakcie",
        done: "Zakonczone",
      },
      module: "Modul",
      noTasks: "Brak zadan. Utworz pierwsze zadanie!",
      save: "Zapisz",
      cancel: "Anuluj",
      delete: "Usun",
    },
    tasksAdv: {
      type: "Typ",
      assignedTo: "Przypisany do",
      dueDate: "Termin",
      totalTasks: "Lacznie",
      aiSuggestions: "Sugestie AI",
      suggest: "Sugeruj",
      suggested: "Sugestie zapisane",
      steps: "Kroki realizacji",
    },
    settings: {
      title: "Ustawienia",
      subtitle: "Konfiguracja systemu Epidemos",
      language: "Jezyk interfejsu",
      theme: "Motyw",
      themeLight: "Jasny",
      themeDark: "Ciemny",
      themeSystem: "Systemowy",
      aiConfig: "Konfiguracja AI",
      defaultModel: "Domyslny model AI",
      save: "Zapisz ustawienia",
      saved: "Ustawienia zapisane",
    },
    // Ogolne
    common: {
      loading: "Ladowanie...",
      error: "Blad",
      success: "Sukces",
      confirm: "Potwierdz",
      search: "Szukaj...",
      version: "Wersja",
    },
  },
  en: {
    // Landing Page
    landing: {
      badge: "New AI Content Marketing Platform",
      heroTitle1: "Publish articles.",
      heroTitle2: "Build visibility.",
      heroDesc: "Platform connecting advertisers with publishers. Generate AI content, publish on hundreds of portals, monitor results. All in one place.",
      ctaStart: "Get started free",
      ctaBrowse: "Browse portals",
      statsPortals: "Portals available",
      statsArticles: "Published articles",
      statsAdvertisers: "Advertisers",
      statsModels: "AI Models",
      featuresTitle: "Everything you need",
      featuresDesc: "Complete AI-powered content marketing platform",
      feature1Title: "Portal Publications",
      feature1Desc: "Order sponsored articles and links on hundreds of portals in Poland and Europe",
      feature2Title: "AI Content Generation",
      feature2Desc: "Generate unique articles with 4 AI models: GPT-4o, Claude, Grok, Gemini",
      feature3Title: "SEO Analysis",
      feature3Desc: "Automatic site analysis, keywords, topic suggestions and strategies",
      feature4Title: "24/7 Monitoring",
      feature4Desc: "AI monitor detects errors, analyzes causes and suggests solutions",
      feature5Title: "Mass Generation",
      feature5Desc: "Generate dozens of articles simultaneously with automatic SEO and images",
      feature6Title: "Trending Topics",
      feature6Desc: "Track trends from Google Trends, Twitter and Reddit in real-time",
      howTitle: "How it works?",
      how1Title: "For Advertisers",
      how1Desc: "Browse portals, choose service (article, link, banner), place order. You can order without an account!",
      how2Title: "AI generates content",
      how2Desc: "AI system selects the best model, generates unique article with SEO, image and meta tags.",
      how3Title: "For Publishers",
      how3Desc: "Add portal, set prices, accept orders. Earn on publications. You can be both publisher and advertiser!",
      blogTitle: "Blog",
      blogDesc: "Latest articles and guides",
      readMore: "Read more",
      ctaTitle: "Ready for more visibility?",
      ctaDesc: "Join thousands of companies building their online presence with Epidemos.",
      ctaFree: "Create free account",
      ctaShop: "Browse shop",
    },
    // Header
    header: {
      features: "Features",
      blog: "Blog",
      shop: "Shop",
      login: "Login",
      register: "Sign up",
    },
    // Footer
    footer: {
      desc: "Platform connecting advertisers with publishers. Publish articles, build links, increase visibility.",
      product: "Product",
      features: "Features",
      pricing: "Pricing",
      shop: "Shop",
      blog: "Blog",
      company: "Company",
      about: "About",
      contact: "Contact",
      legal: "Legal",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      rights: "All rights reserved.",
    },
    // Features Page
    featuresPage: {
      heroTitle: "Complete platform for",
      heroTitle2: "content marketing",
      heroDesc: "Everything you need to build online visibility. For advertisers and publishers.",
      ctaStart: "Get started free",
      ctaShop: "View offers",
      tabAdvertiser: "For Advertisers",
      tabPublisher: "For Publishers",
      // Advertiser features
      advMarketplace: "Portal Marketplace",
      advMarketplaceDesc: "Browse hundreds of verified portals across different categories. Filter by industry, price, SEO parameters and reach.",
      advOrdering: "Order Articles",
      advOrderingDesc: "Order a sponsored article or submit your own text. Choose publication type: article, banner, in-text link or social media post.",
      advAiGen: "AI Content Generator",
      advAiGenDesc: "Generate professional articles using artificial intelligence. Choose topic, tone and length - the rest is done automatically.",
      advNegotiation: "Price Negotiation",
      advNegotiationDesc: "Negotiate prices directly with publishers. The negotiation system allows you to get better terms for larger orders.",
      advWallet: "Zorki Wallet",
      advWalletDesc: "Epidemos virtual currency. Top up your wallet and pay for orders without fees. Option to apply for publication credit.",
      advReports: "Reports Panel",
      advReportsDesc: "Track your order status in real-time. Download reports from published articles and monitor results.",
      // Publisher features
      pubAddSites: "Add Portals",
      pubAddSitesDesc: "Add your websites to the marketplace. Set pricing, categories and types of accepted publications.",
      pubWordpress: "WordPress API Integration",
      pubWordpressDesc: "As the FIRST platform in Poland, we offer full WordPress integration! Articles are published automatically on your site.",
      pubManageOffers: "Manage Offers",
      pubManageOffersDesc: "Create pricing for each site separately. Set prices for articles, banners, links and social media posts.",
      pubModeration: "Order Moderation",
      pubModerationDesc: "Review and accept orders before publication. You have full control over content on your portals.",
      pubEarnings: "Earnings & Payouts",
      pubEarningsDesc: "Track your earnings in the panel. Request payouts to bank account or PayPal with no minimum thresholds.",
      pubRss: "RSS Sources",
      pubRssDesc: "Add RSS sources for automatic article import. System fetches content and prepares it for publication.",
      // Upcoming
      upcomingTitle: "Coming Soon",
      upcomingDesc: "We're working on new features",
      upcoming1: "Guest Article Database",
      upcoming1Desc: "Ready articles to download from database. AI searches and prepares content matched to your industry.",
      upcoming2: "AI-Found News",
      upcoming2Desc: "Automatic search for current news and trends. AI generates articles based on current events.",
      upcoming3: "Links & Domains Database",
      upcoming3Desc: "Extensive database of domains with SEO parameters. Find the best places for linking.",
      upcoming4: "Automatic Campaigns",
      upcoming4Desc: "Set budget and goals - AI will select the best portals and distribute publications over time.",
      statusInPrep: "In preparation",
      statusSoon: "Soon",
      statusPlanned: "Planned",
      // Benefits
      benefitsTitle: "Why Epidemos?",
      benefit1: "Time savings - publication automation",
      benefit2: "Security - verified portals",
      benefit3: "SEO effects - link building",
      benefit4: "Publisher network - hundreds of portals",
      benefit5: "AI - content generation",
      benefit6: "24/7 - platform access",
      // CTA
      ctaTitle: "Ready for more visibility?",
      ctaDesc: "Join thousands of companies building their online presence",
      ctaFreeAccount: "Create free account",
      // Stats
      statsPortals: "Portals in network",
      statsArticles: "Published articles",
      statsAdvertisers: "Advertisers",
      statsModels: "AI Models",
    },
    // Public Shop
    publicShop: {
      title: "Marketplace",
      subtitle: "Order sponsored articles and links on verified portals",
      searchPlaceholder: "Search portal...",
      allCategories: "All categories",
      results: "results",
      noResults: "No portals match criteria",
      noResultsHint: "Try changing filters or search",
      article: "Article",
      link: "Link",
      banner: "Banner",
      order: "Order",
      details: "Details",
      visitors: "visits/month",
      delivery: "days delivery",
      from: "from",
      loginToOrder: "Login to order",
      guestOrder: "Order without account",
      negotiate: "Negotiate price",
      commission: "Portal commission",
      // Order dialog
      orderTitle: "New Order",
      selectService: "Select service",
      orderDetails: "Order details",
      summary: "Summary",
      articleTitle: "Article title",
      articleContent: "Article content",
      contentHint: "Leave empty - publisher will write article",
      requirements: "Additional requirements",
      requirementsPlaceholder: "Additional instructions for publisher...",
      yourEmail: "Your email",
      emailHint: "You'll receive status updates at this address",
      next: "Next",
      back: "Back",
      placeOrder: "Place order",
      orderPlaced: "Order placed!",
      orderPlacedDesc: "Publisher has been notified and will respond soon",
      total: "Total",
      service: "Service",
      portal: "Portal",
      // Negotiation
      negotiateTitle: "Negotiate price",
      proposedPrice: "Proposed price",
      message: "Message to publisher",
      sendOffer: "Send offer",
      offerSent: "Offer sent",
    },
    auth: {
      login: "Login",
      register: "Register",
      identifier: "Login",
      identifierPlaceholder: "Email, phone or nickname",
      identifierHint: "Use email, phone number or nickname",
      password: "Password",
      role: "Role",
      advertiser: "Advertiser",
      publisher: "Publisher",
      loginBtn: "Log in",
      registerBtn: "Register",
      loginSuccess: "Logged in successfully",
      registerSuccess: "Account created",
      logout: "Logout",
    },
    shop: {
      title: "Advertiser Shop",
      subtitle: "Order articles, links and banners on publisher portals",
      searchTab: "Search Portals",
      myOrders: "My Orders",
      searchPlaceholder: "Search portal...",
      allCategories: "All Categories",
      allRegions: "All Regions",
      results: "results",
      noResults: "No publisher offers",
      addOffersHint: "Add offers in publisher panel",
      article: "Article",
      link: "Link",
      banner: "Banner",
      order: "Order",
      noOrders: "No orders",
      newOrder: "New Order",
      selectType: "Select service type",
      next: "Next",
      back: "Back",
      summary: "Summary",
      orderTitle: "Title",
      orderTitlePlaceholder: "Article title or description...",
      orderContent: "Article content",
      contentPlaceholder: "Enter content or leave empty - publisher will write",
      linkUrl: "Link URL",
      requirements: "Requirements",
      requirementsPlaceholder: "Additional instructions...",
      guestEmail: "Contact email",
      guestHint: "Order without account - you'll receive status via email",
      enterEmail: "Enter email",
      portal: "Portal",
      type: "Type",
      delivery: "Delivery",
      days: "days",
      total: "Total",
      placeOrder: "Place Order",
      orderCreated: "Order placed",
      portals: "portals",
      portalsSelected: "portals selected",
      orderMulti: "Order on selected",
      stripeNote: "Payment: Stripe (placeholder). Publisher will be notified.",
    },
    pub: {
      title: "Publisher Panel",
      subtitle: "Manage sites, offers and orders",
      sitesTab: "My Sites",
      ordersTab: "Orders",
      mySites: "Sites",
      totalOrders: "Orders",
      pendingOrders: "Pending",
      completedOrders: "Completed",
      revenue: "Revenue",
      addSite: "Add Site",
      siteName: "Portal Name",
      category: "Category",
      region: "Region",
      pricing: "Service Pricing",
      pubPrice: "Publication",
      writePrice: "Writing",
      linkPrice: "Link",
      description: "Description",
      noSites: "No sites. Add your portal!",
      noOrders: "No orders",
      pending: "pending",
      accepted: "Accepted",
      completed: "Completed",
      ordersTotal: "orders",
      accept: "Accept",
      reject: "Reject",
      markComplete: "Complete",
      siteAdded: "Site added with offer",
      platform: "Platform",
      wpUser: "WP Username",
      wpPass: "Application Password",
      manualApproval: "Manual publication approval",
      manualApprovalHint: "Enable to manually approve every publication",
    },
    admin: {
      title: "Admin Panel",
      subtitle: "System management, users and orders",
      noAccess: "Access denied - Admin role required",
      overviewTab: "Overview",
      usersTab: "Users",
      ordersTab: "Orders",
      users: "Users",
      sites: "Sites",
      orders: "Orders",
      revenue: "Revenue",
      posts: "Articles",
      userBreakdown: "Users by Role",
      orderBreakdown: "Orders by Status",
      financials: "Financials",
      totalRevenue: "Total revenue from orders",
      userIdent: "Identifier",
      displayName: "Name",
      role: "Role",
      registered: "Registered",
      noOrders: "No orders",
      orderType: "Type",
      site: "Portal",
      client: "Client",
      price: "Price",
    },
    nav: {
      dashboard: "Dashboard",
      shop: "Shop",
      myOrders: "My Orders",
      myNegotiations: "My Negotiations",
      zorki: "Zorki Wallet",
      publisher: "Publisher Panel",
      admin: "Admin Panel",
      sites: "Sites",
      htmlGenerator: "HTML Generator",
      generator: "Content Generator",
      monitor: "AI Monitor",
      trends: "Trending Topics",
      rewrite: "Rewrite Article",
      massGen: "Mass Generate",
      autoPublish: "Auto Publisher",
      keywordResearch: "Keyword Research",
      breakingNews: "Breaking News",
      performance: "Efektywnosc",
      internalLinking: "Internal Linking",
      clickbait: "CTR Optimizer",
      twitterAnalysis: "X/Twitter Analysis",
      seoAgent: "SEO Agent",
      affiliates: "Affiliate Products",
      woo: "WooCommerce",
      social: "Social Media",
      reports: "Reports",
      comments: "Comments",
      forums: "Forums",
      connectors: "API Connectors",
      extensions: "Extensions",
      subscription: "Subscription",
      mail: "Mail",
      messages: "Messages",
      media: "Media Library",
      rss: "RSS Sources",
      queue: "Post Queue",
      tasks: "Tasks",
      settings: "Settings",
      collapse: "Collapse menu",
    },
    htmlGen: {
      title: "HTML Site Generator",
      subtitle: "Create complete HTML sites with AI and deploy via FTP",
      wizard: "Wizard",
      history: "Generation History",
      maxVersions: "Max 3 versions per domain",
      noHistory: "No generation history",
      stepDomain: "Domain",
      stepAnalysis: "AI Analysis",
      stepTemplate: "Template",
      stepFtp: "FTP",
      stepGenerate: "Generate",
      stepPreview: "Preview",
      domainLabel: "Domain",
      aiModelLabel: "AI Model",
      analyzeDomain: "Analyze Domain",
      analyzing: "Analyzing...",
      analysisComplete: "Analysis complete",
      analysisResult: "Analysis Result",
      category: "Category",
      language: "Language",
      siteTitle: "Site Title",
      siteDesc: "Site Description",
      keywords: "Keywords",
      suggestedArticles: "Suggested Articles",
      enterDomain: "Enter domain",
      selectTemplate: "Select Template",
      selected: "Selected",
      template: "Template",
      ftpConfig: "FTP Configuration",
      ftpOptional: "FTP is optional. You can skip this step and download files manually.",
      ftpHost: "FTP Host",
      ftpUser: "FTP User",
      ftpPass: "FTP Password",
      enterFtpHost: "Enter FTP host",
      testFtp: "Test Connection",
      generateSummary: "Summary and Generation",
      generateWillCreate: "The system will generate the following files:",
      generateNow: "Generate Site",
      generating: "Generating...",
      generateSuccess: "Site generated successfully",
      previewTitle: "Site Preview",
      generated: "Generated",
      deployFtp: "Deploy to FTP",
      newGeneration: "New Generation",
      date: "Date",
      back: "Back",
      nextTemplate: "Select Template",
      nextFtp: "FTP Configuration",
      nextGenerate: "Summary",
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Epidemos central management panel",
      sites: "Sites",
      posts: "Articles",
      published: "Published",
      drafts: "Drafts",
      pending: "Pending",
      activeJobs: "Active AI Jobs",
      rssFeeds: "RSS Feeds",
      pendingTasks: "Pending Tasks",
      totalJobs: "Total Jobs",
      recentActivity: "Recent Activity",
      quickActions: "Quick Actions",
      addSite: "Add Site",
      generateArticle: "Generate Article",
      addFeed: "Add RSS Feed",
      createTask: "Create Task",
      noActivity: "No activity yet",
      wpSites: "WordPress Sites",
      htmlSites: "HTML Sites",
      activeSites: "Active Sites",
      totalArticles: "Total Articles",
      recentJobs: "Recent AI Jobs",
      noJobs: "No AI jobs yet",
      jobType: "Job Type",
      jobStatus: "Status",
      jobModel: "AI Model",
      jobDate: "Date",
      systemModules: "System Modules",
      moduleActive: "Active",
      modulePlanned: "Planned",
      subscription: "Subscription",
      plan: "Plan",
      free: "Free",
      pro: "Professional",
      enterprise: "Enterprise",
      sitesUsed: "Sites",
      postsUsed: "Articles",
      aiUsage: "AI Model Usage",
      generate: "generate",
      rewrite: "rewrite",
      seo_analyze: "seo_analyze",
      mass_generate: "mass_generate",
      completedJobs: "Completed",
      failedJobs: "Failed",
      tasksInProgress: "In Progress",
      tasksDone: "Done",
      refreshData: "Refresh Data",
      lastUpdate: "Last update",
    },
    sites: {
      title: "Sites Management",
      subtitle: "WordPress and HTML sites",
      addSite: "Add Site",
      name: "Site Name",
      url: "URL Address",
      type: "Site Type",
      wordpress: "WordPress",
      html: "HTML",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      actions: "Actions",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      noSites: "No sites yet. Add your first site!",
      ftpHost: "FTP Host",
      ftpUser: "FTP User",
      ftpPass: "FTP Password",
      wpApiUrl: "WordPress API URL",
      wpApiUser: "WordPress User",
      wpApiPass: "WordPress Password",
      confirmDelete: "Are you sure you want to delete this site?",
    },
    wp: {
      overview: "Overview",
      aiAnalysis: "AI Analysis",
      pricing: "Ad Pricing",
      directories: "Directories",
      testConnection: "Test Connection",
      connectionOk: "Connection successful",
      connectionFail: "Connection failed",
      posts: "posts",
      category: "Category",
      region: "Region",
      audience: "Target Audience",
      traffic: "Traffic",
      assignCategory: "Assign Category",
      assignRegion: "Assign Region",
      publishedArticles: "Published",
      backlinks: "Backlinks",
      runAnalysis: "Run AI Analysis",
      analyzing: "Analyzing...",
      analysisComplete: "Analysis complete",
      categories: "Categories",
      strengths: "Strengths",
      suggestedTopics: "Suggested Topics",
      seoKeywords: "SEO Keywords",
      seoStrategies: "SEO Strategies",
      analyzedAt: "Analyzed at",
      generatePricing: "Generate Ad Pricing",
      generatingPricing: "Generating pricing...",
      pricingGenerated: "Pricing generated",
      adType: "Ad Type",
      duration: "Duration",
      price: "Price",
      pricingGenAt: "Generated at",
      directoriesDesc: "Submit site to directories to increase visibility and gain backlinks.",
      submitDirectories: "Submit to Directories",
      directoriesSubmitted: "Submitted to directories",
      sent: "Sent",
    },
    monitor: {
      title: "AI Monitor",
      subtitle: "Error monitoring and automated AI analysis",
      runScan: "Scan System",
      scanning: "Scanning...",
      scanComplete: "Scan complete",
      errorsFound: "errors found",
      newAlerts: "new alerts",
      totalAlerts: "Total Alerts",
      critical: "Critical",
      highPriority: "High Priority",
      resolved: "Resolved",
      alertsList: "Alerts List",
      noAlerts: "No alerts - system running correctly",
      allSeverity: "Severity",
      allStatus: "Status",
      statusNew: "New",
      statusAck: "Acknowledged",
      statusResolved: "Resolved",
      statusIgnored: "Ignored",
      details: "Details",
      aiAnalysis: "AI Analysis",
      analyzeError: "Analyze Error",
      analyzing: "Analyzing...",
      analysisComplete: "Analysis complete",
      cause: "Cause",
      solution: "Solution",
      urgent: "Urgent",
      impact: "Impact",
      acknowledge: "Acknowledge",
      resolve: "Resolve",
      ignore: "Ignore",
      lastScan: "Last scan",
    },
    trends: {
      title: "Trending Topics",
      subtitle: "Trending topics from Google Trends, Twitter and Reddit",
      fetchTrends: "Fetch Trends",
      fetching: "Fetching...",
      fetchComplete: "Fetch complete",
      topicsFetched: "topics fetched",
      saved: "saved",
      addManual: "Add Manual Topic",
      topicTitle: "Topic Title",
      topicDesc: "Description",
      category: "Category",
      source: "Source",
      expiresIn: "Expires in",
      keywords: "Keywords",
      activeTrends: "Active Trends",
      expired: "Expired",
      allCategories: "All Categories",
      allSources: "All Sources",
      noTrends: "No trends yet. Fetch new topics!",
      timeLeft: "Time Left",
      used: "Used",
      aiScoring: "AI Scoring",
      scoreNow: "Score Topic",
      scored: "Score saved",
      competition: "Competition",
      traffic: "Traffic",
      bestTime: "Best Time",
      altTitles: "Alternative Titles",
      generateArticle: "Generate article from this topic",
      lastFetch: "Last fetch",
    },
    rewrite: {
      title: "Rewrite Article",
      subtitle: "Content uniqueness with AI assistance",
      rewriteTab: "Rewrite",
      historyTab: "History",
      sourceUrl: "Source URL",
      enterUrl: "Enter article URL",
      scrape: "Scrape",
      scraped: "Scraped",
      words: "words",
      options: "Rewrite Options",
      aiModel: "AI Model",
      language: "Language",
      tone: "Tone",
      tonePro: "Professional",
      toneCasual: "Casual",
      toneSeo: "SEO",
      targetSite: "Target Site",
      autoSeo: "Auto SEO meta tags",
      saveAs: "Save as",
      asDraft: "Draft",
      asPending: "Pending",
      rewriteNow: "Rewrite Article",
      rewriting: "Rewriting...",
      rewriteComplete: "Article rewritten",
      newRewrite: "New Rewrite",
      originalPreview: "Original Preview",
      rewrittenPreview: "Rewritten Preview",
      done: "Done",
      pasteUrlHint: "Paste an article URL to rewrite",
      noHistory: "No rewrite history",
    },
    mass: {
      title: "Mass Generation",
      subtitle: "Generate multiple articles simultaneously with AI",
      generateTab: "Generate",
      historyTab: "History",
      modeAndTopics: "Mode & Topics",
      mode: "Mode",
      modeCustom: "Custom",
      modeReviews: "Reviews",
      modeLocal: "Local",
      category: "Category",
      topicPlaceholder: "Enter article topic...",
      add: "Add",
      suggest: "AI Suggest",
      suggested: "Topics suggested",
      noTopics: "Add topics manually or use AI suggestions",
      topicsAdded: "topics",
      addTopicsFirst: "Add topics first",
      settings: "Generation Settings",
      aiModel: "AI Model",
      language: "Language",
      tone: "Tone",
      tonePro: "Professional",
      toneCasual: "Casual",
      wordCount: "Length",
      targetSite: "Target Site",
      includeFaq: "Include FAQ section",
      includeLinks: "Internal links",
      saveAs: "Save as",
      asDraft: "Draft",
      asPending: "Pending",
      generateBatch: "Generate Batch",
      generatingBatch: "Generating...",
      pleaseWait: "This may take a few minutes...",
      generated: "Generated",
      articles: "articles",
      articlesGenerated: "articles generated",
      failed: "failed",
      words: "words",
      newBatch: "New Batch",
      noBatches: "No generation history",
    },
    affil: {
      title: "Affiliate Products",
      subtitle: "Manage products for article promotion",
      addProduct: "Add Product",
      productName: "Product Name",
      productUrl: "Product URL",
      description: "Description",
      imageUrl: "Image URL",
      category: "Category",
      tags: "Tags",
      priority: "Priority",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      ctaText: "CTA Text",
      commission: "Commission",
      autoInsert: "Auto-insert",
      total: "total",
      allCategories: "All",
      noProducts: "No affiliate products yet",
    },
    woo: {
      title: "WooCommerce Products",
      subtitle: "Manage products for sale",
      addProduct: "Add Product",
      productName: "Product Name",
      regularPrice: "Price",
      salePrice: "Sale Price",
      costPrice: "Cost",
      margin: "Margin",
      shortDesc: "Short Description",
      category: "Category",
      tags: "Tags",
      imageUrl: "Image URL",
      stock: "Stock",
      inStock: "In Stock",
      outOfStock: "Out of Stock",
      targetSite: "WP Site",
      publish: "Publish",
      published: "Published",
      totalProducts: "Products",
      publishedProducts: "Published",
      draftProducts: "Drafts",
      noProducts: "No WooCommerce products yet",
    },
    social: {
      title: "Social Media",
      subtitle: "Schedule and publish posts on social platforms",
      createPost: "Create Post",
      platforms: "Platforms",
      content: "Content",
      contentPlaceholder: "Write your post...",
      imageUrl: "Image URL",
      linkUrl: "Link URL",
      scheduleAt: "Schedule at",
      enterContent: "Enter post content",
      selectPlatform: "Select a platform",
      publish: "Publish",
      published: "Published",
      totalPosts: "Posts",
      scheduled: "Scheduled",
      publishedCount: "Published",
      noPosts: "No social media posts yet",
    },
    reports: {
      title: "Mobile Reports",
      subtitle: "Receive and process field reports",
      submitReport: "Submit Report",
      headline: "Headline",
      content: "Content",
      location: "Location",
      category: "Category",
      reporter: "Reporter",
      submit: "Submit",
      totalReports: "Reports",
      newReports: "New",
      approvedReports: "Approved",
      noReports: "No reports yet",
      aiSuggestions: "AI Suggestions",
      getSuggestions: "Suggest",
      suggested: "Suggestions saved",
      suggestedTitle: "Suggested title",
      suggestedStyle: "Style",
      approve: "Approve",
      reject: "Reject",
    },
    comments: {
      title: "Comments",
      subtitle: "Manage comments and AI auto-replies",
      addManual: "Add Comment",
      importWp: "Import from WP",
      imported: "Imported",
      author: "Author",
      content: "Comment content",
      postTitle: "Post title",
      total: "total",
      new: "new",
      repliedCount: "replied",
      allSources: "All Sources",
      noComments: "No comments yet",
      analyzeSentiment: "Sentiment",
      aiReply: "AI Reply",
      generateReply: "Generate",
      replied: "Reply generated",
      toneFriendly: "Friendly",
      tonePro: "Professional",
      toneHumor: "Humorous",
    },
    forums: {
      title: "Forums",
      subtitle: "Publish on internet forums (MyBB, phpBB)",
      addForum: "Add Forum",
      createPost: "Create AI Post",
      forumsTab: "Forums",
      postsTab: "Posts",
      forumName: "Forum Name",
      forumUrl: "Forum URL",
      selectForum: "Select Forum",
      postTitle: "Post Title",
      postContent: "Content",
      contentHint: "Enter topic or draft - AI will expand",
      category: "Category",
      other: "Other",
      generateAndSave: "Generate & Save",
      postCreated: "Post generated",
      publish: "Publish",
      published: "Published",
      posts: "posts",
      discussions: "discussions",
      noForums: "No forums. Add your first forum!",
      noPosts: "No forum posts yet",
      sectionId: "Section ID",
      apiKey: "API Key",
      tags: "Tags",
      forumsCount: "Forums",
      postsCount: "Posts",
      pendingApproval: "Pending",
      publishedCount: "Published",
      approved: "Approved",
      rejected: "Rejected",
      approve: "Approve",
      reject: "Reject",
      aiGenerated: "AI Content",
      replies: "Replies",
      views: "Views",
    },
    conn: {
      title: "API Connectors",
      subtitle: "Configure external service connections",
      addConnector: "Add Connector",
      connName: "Name",
      platform: "Platform",
      apiUrl: "API URL",
      apiKey: "API Key",
      authType: "Auth Type",
      capabilities: "Capabilities",
      rateLimit: "Rate limit (/h)",
      costPerCall: "Cost / call",
      testConnection: "Test Connection",
      noConnectors: "No API connectors yet",
    },
    ext: {
      title: "Extensions",
      subtitle: "Additional modules and integrations for Epidemos",
      total: "available",
      installedCount: "installed",
      installedSection: "Installed",
      availableSection: "Available",
      install: "Install",
      installed: "Installed",
      uninstall: "Uninstall",
      uninstalled: "Uninstalled",
    },
    sub: {
      title: "Subscription",
      subtitle: "Manage plan and account limits",
      currentPlan: "Current Plan",
      currentPlanBtn: "Current Plan",
      sites: "Sites",
      postsMonth: "Posts/mo",
      aiCalls: "AI calls/mo",
      rssFeeds: "RSS feeds",
      expiresAt: "Valid until",
      month: "mo",
      upgrade: "Change Plan",
      downgrade: "Change",
      planChanged: "Plan changed",
      stripeNote: "Payments powered by Stripe. Subscriptions can be cancelled anytime.",
    },
    media: {
      title: "Media Library",
      subtitle: "Image bank with categories and AI tagging",
      bulkUpload: "Bulk Upload",
      selectCategory: "Image category",
      selectFiles: "Select files",
      filesSelected: "files selected",
      upload: "Upload",
      noMedia: "No images in library",
      uploadHint: "Add images in bulk by selecting a category",
    },
    generator: {
      title: "AI Content Generator",
      subtitle: "Create articles with AI assistance",
      topic: "Article Topic",
      topicPlaceholder: "Enter article topic...",
      model: "AI Model",
      language: "Language",
      tone: "Tone",
      toneOptions: {
        professional: "Professional",
        casual: "Casual",
        seo: "SEO Optimized",
      },
      wordCount: "Word Count",
      keywords: "SEO Keywords",
      keywordsPlaceholder: "Separate with commas...",
      targetSite: "Target Site",
      selectSite: "Select site (optional)",
      generate: "Generate Article",
      generating: "Generating...",
      preview: "Article Preview",
      noContent: "Generate an article to see preview",
      saveAsDraft: "Save as Draft",
      copyContent: "Copy Content",
      wordsGenerated: "words generated",
      modelUsed: "Model used",
    },
    rss: {
      title: "RSS Sources",
      subtitle: "Manage RSS feeds",
      addFeed: "Add Feed",
      name: "Name",
      url: "Feed URL",
      autoImport: "Auto Import",
      interval: "Check Interval (min)",
      lastChecked: "Last Checked",
      imported: "Imported",
      noFeeds: "No RSS feeds yet. Add your first feed!",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
    },
    rssAdv: {
      feedsTab: "Feeds",
      pendingTab: "Pending",
      test: "Test",
      testOk: "Feed valid",
      testFail: "Feed error",
      articles: "articles",
      found: "found",
      import: "Import",
      imported: "Imported",
      targetSite: "Target Site",
      lastCheck: "Last Import",
      noPending: "No pending articles",
      original: "Original",
      aiRating: "AI Rating",
      rateArticle: "Rate Article",
      rated: "Rating saved",
      quality: "Quality",
      relevance: "Relevance",
      rewritePotential: "Rewrite Potential",
      action: "Recommendation",
      approve: "Approve",
      reject: "Reject",
      statusPending: "Pending",
      statusApproved: "Approved",
      statusRejected: "Rejected",
    },
    queue: {
      title: "Post Queue",
      subtitle: "Articles awaiting publication",
      noPosts: "No posts in queue",
      publish: "Publish",
      edit: "Edit",
      delete: "Delete",
      filter: "Filter",
      all: "All",
      draft: "Drafts",
      pending: "Pending",
      published: "Published",
    },
    queueAdv: {
      total: "Total",
      drafts: "Drafts",
      pending: "Pending",
      publishedCount: "Published",
      rejectedCount: "Rejected",
      selected: "selected",
      approveSelected: "Approve",
      rejectSelected: "Reject",
      approved: "Approved",
      rejected: "Rejected",
      published: "Published",
      titleCol: "Title",
      statusCol: "Status",
      siteCol: "Site",
      wordsCol: "Words",
      dateCol: "Date",
      page: "Page",
      words: "words",
      preview: "Preview",
      assignSite: "Assign Site",
      publishNow: "Publish Now",
      moveToPending: "Move to Pending",
      reject: "Reject",
      created: "Created",
    },
    tasks: {
      title: "Tasks",
      subtitle: "System task management",
      addTask: "Add Task",
      taskTitle: "Task Title",
      description: "Description",
      priority: "Priority",
      priorities: {
        low: "Low",
        medium: "Medium",
        high: "High",
        critical: "Critical",
      },
      status: "Status",
      statuses: {
        todo: "To Do",
        in_progress: "In Progress",
        done: "Done",
      },
      module: "Module",
      noTasks: "No tasks yet. Create your first task!",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
    },
    tasksAdv: {
      type: "Type",
      assignedTo: "Assigned to",
      dueDate: "Due Date",
      totalTasks: "Total",
      aiSuggestions: "AI Suggestions",
      suggest: "Suggest",
      suggested: "Suggestions saved",
      steps: "Steps",
    },
    settings: {
      title: "Settings",
      subtitle: "Epidemos system configuration",
      language: "Interface Language",
      theme: "Theme",
      themeLight: "Light",
      themeDark: "Dark",
      themeSystem: "System",
      aiConfig: "AI Configuration",
      defaultModel: "Default AI Model",
      save: "Save Settings",
      saved: "Settings saved",
    },
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      confirm: "Confirm",
      search: "Search...",
      version: "Version",
    },
  },
};

export default translations;
